import React from 'react';
import { PageLayout } from '../../components/shared/PageLayout';
import { Seo } from '../../components/shared/Seo';
import { HeroSection, type CtaButton } from '../../components/shared/HeroSection';
import { ContactInfoSection } from './components/ContactInfoSection';
import { ContactFormSection } from './components/ContactFormSection';
import { MapSection } from './components/MapSection';

const ContactPage: React.FC = () => {
  const ctaButtons: CtaButton[] = [
    { text: 'Call Now: +91 8714014140', link: 'tel:+918714014140', variant: 'primary', icon: 'ri-phone-line' },
    { text: 'WhatsApp Us', link: 'https://wa.me/918714014140', variant: 'outline', icon: 'ri-whatsapp-line' }
  ];

  const structuredData = {
    "@context": "https://schema.org", "@type": "ContactPage", "name": "Contact Device Doctor - Mobile Repair Center Kochi", "description": "Contact information for Device Doctor mobile repair center in Kochi, Kerala", "url": "https://devicedoctor.in/contact", "mainEntity": { "@type": "LocalBusiness", "name": "Device Doctor", "address": { "@type": "PostalAddress", "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn", "addressLocality": "Kochi", "addressRegion": "Kerala", "postalCode": "682019", "addressCountry": "IN" }, "geo": { "@type": "GeoCoordinates", "latitude": 9.970602883213246, "longitude": 76.3186668593356 }, "telephone": "+918714014140", "email": "info@devicedoctor.com", "openingHours": ["Mo-Sa 10:00-19:00", "Su 11:00-16:00"], "sameAs": ["https://www.facebook.com/people/Device-Doctor", "https://instagram.com/device_doctor_", "https://youtube.com/@mobilerepairkerala"] }
  };
  
  return (
    <PageLayout>
      <Seo
        title="Contact Device Doctor Kochi - Mobile Repair Center Vyttila | Call +91 8714014140"
        description="Contact Device Doctor in Kochi for mobile and laptop repair services. Located at Vyttila Junction near Nakshatra Jewellery. Call +91 8714014140 or visit our store. Open Mon-Sat 10AM-7PM, Sun 11AM-4PM."
        keywords="contact device doctor, mobile repair kochi contact, phone repair vyttila address, device doctor location, mobile service center contact kochi"
        structuredData={structuredData}
      />
      <h1 style={{ position: 'absolute', left: '-9999px' }}>Contact Device Doctor - Mobile Repair Center Kochi Vyttila</h1>

      <HeroSection
        title={<span>Get in Touch with <span className="text-red-400">Device Doctor</span></span>}
        subtitle="Ready to fix your device? Visit our Kochi store or contact us for expert mobile and laptop repair services. We're here to help with all your electronic device needs."
        badge={{ text: 'Contact Us', icon: 'ri-phone-line' }}
        ctaButtons={ctaButtons}
        backgroundImage="/assets/contact-hero.jpg"
      />

      <ContactInfoSection />
      <ContactFormSection />
      <MapSection />
    </PageLayout>
  );
};

export default ContactPage;
export { ContactPage };